module.exports = __webpack_public_path__ + "0af5d249/img/send-icon.3cfb6275.svg";